<template>
  <v-container fluid>
    <v-form ref="form">
      <v-row class="header py-6 px-4" justify="center">
        <v-col class="text-center">
          <span class="text-h5 font-weight-bold pl-16">{{ $t("Upload a new ad") }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-16 px-16 mx-16">
        <v-col>
          <span class="text-h5 font-weight-bold">{{ $t("For the upliftment of the soul/ healing/ success/ all salvations") }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-8 px-16 mx-16">
        <v-col>
          <span class="text-h6 font-weight-bold">{{ $t("Select the type of dedication") }}</span>
        </v-col>
      </v-row>
      <v-row class="pt-4 px-16 mx-16">
        <v-col
          cols="auto"
          class="dedication-tab me-4"
          :class="item.value === selectedDedication ? 'active' : ''"
          v-for="(item, index) in dedicationOptions"
          :key="index"
          @click="onSelectDedication(item)"
        >
          <span class="text-subtitle-2">{{ item.label }}</span>
        </v-col>
      </v-row>
      <v-row class="pt-4 px-16 mx-16">
        <v-col cols="3" class="px-0">
          <v-text-field
            :label="$t('name')"
            dense
            outlined
            hide-no-data
            hide-details
            v-model="name"
            :rules="[rules.required]"
          >
            <template v-slot:prepend-inner>
              <v-icon color="black">mdi-square-edit-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0 px-16 mx-16">
        <v-radio-group
          v-model="gender"
          row
          dense
        >
          <v-radio
            :label="$t('Son')"
            value="male"
            color="#747474"
          ></v-radio>
          <v-radio
            :label="$t('Daughter')"
            value="female"
            color="#747474"
          ></v-radio>
        </v-radio-group>
      </v-row>
      <v-row class="mt-0 px-16 mx-16">
        <v-col cols="3" class="px-0">
          <v-text-field
            :label="$t('Mother name')"
            dense
            outlined
            hide-no-data
            hide-details
            v-model="motherName"
            :rules="[rules.required]"
          >
            <template v-slot:prepend-inner>
              <v-icon color="black">mdi-square-edit-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-8 px-16 mx-16">
        <v-col>
          <span class="text-h6 font-weight-bold">{{ $t('Donated by') }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-0 px-16 mx-16 align-center">
        <v-col cols="3" class="px-0">
          <v-text-field
            :label="$t('name')"
            dense
            outlined
            hide-no-data
            hide-details
            v-model="donorName"
          >
            <template v-slot:prepend-inner>
              <v-icon color="black">mdi-square-edit-outline</v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="auto">
          <v-radio-group
            v-model="isAnonymous"
            row
            dense
          >
            <v-radio
              :label="$t('anonymous')"
              :value="true"
              color="#747474"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-8 px-16 mx-16">
        <v-col>
          <span class="text-h6 font-weight-bold">{{ $t('posting time') }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-0 px-16 mx-16">
        <v-radio-group
          v-model="postSchedule"
          dense
        >
          <v-radio
            :label="$t('now')"
            :value="1"
            color="#747474"
            class="mb-0"
          ></v-radio>
          <div class="text-caption text-start ms-8 mb-4">{{ $t('Will be published in a few minutes') }}</div>
          <v-radio
            :label="$t('timing')"
            :value="2"
            color="#747474"
            class="mb-0"
          ></v-radio>
          <div class="text-caption text-start ms-8">{{ $t('Determine when it will be published') }}</div>
        </v-radio-group>
      </v-row>
      <v-row class="mt-0 px-16 mx-16 align-center">
        <v-col cols="auto">
          <v-row>
            <v-col cols="auto" class="px-0">
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    class="date-input"
                    append-icon="mdi-menu-down"
                    hide-details
                    persistent-hint
                    readonly
                    dense
                    outlined
                    single-line
                    v-bind="attrs"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    no-title
                    @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="auto" class="px-0">
              <v-menu
                ref="menu"
                v-model="timeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="time"
                    class="date-input"
                    append-icon="mdi-menu-down"
                    hide-details
                    readonly
                    dense
                    single-line
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeMenu"
                  v-model="time"
                  full-width
                  @click:minute="$refs.menu.save(time)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto">
          <span class="text-subtitle-2">{{ $t('To: Israel Time') }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-8 px-16 mx-16">
        <v-col cols="1">
          <v-btn
            depressed
            block
            rounded
            color="primary"
            :loading="this.loading"
            :disabled="this.loading || !this.uploadValid"
            @click="onAddAd"
          >
            {{ $t('routine') }}
            <v-icon right>
              mdi-arrow-left-thin
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from "moment/moment";
import api from "@/api/api";

export default {
  data() {
    return {
      dedicationOptions: [
        {
          value: 'upliftment_soul',
          label: this.$t('Upliftment of the soul')
        },
        {
          value: 'healing',
          label: this.$t('Healing')
        },
        {
          value: 'success',
          label: this.$t('Success')
        },
        {
          value: 'decent_pairing',
          label: this.$t('Decent pairing')
        },
        {
          value: 'salvation',
          label: this.$t('Salvation')
        },
        {
          value: 'repent',
          label: this.$t('Repent')
        }
      ],
      selectedDedication: 'upliftment_soul',
      name: '',
      gender: 'male',
      motherName: '',
      postSchedule: 1,
      isAnonymous: false,
      donorName: '',
      dateMenu: false,
      timeMenu: false,
      date: moment(new Date()).format('YYYY-MM-DD'),
      dateFormatted: this.formatDate(moment(new Date()).format('YYYY-MM-DD')),
      time: null,
      loading: false,
      rules: {
        required: value => !!value || 'Required.',
      },
    }
  },
  computed: {
    donateId() {
      return this.$route.params.donate_id || null
    },
    isDonateBanner() {
      return !!this.donateId
    },
    uploadValid () {
      return this.name !== "" && this.motherName !== '' && this.validateScheduledDate();
    }
  },
  watch: {
    donorName(newVal) {
      if (newVal && newVal.trim() !== '') {
        this.isAnonymous = false
      }
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    onSelectDedication(item) {
      this.selectedDedication = item.value;
    },
    onAddAd() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.loading = true
      const params = {
        banner: {
          name: this.name,
          mother_name: this.motherName,
          gender: this.gender,
          is_anonymous: this.isAnonymous,
          donor_name: this.donorName,
          dedication: this.selectedDedication,
        }
      };
      if (this.postSchedule === 2) {
        params.banner.scheduled_at = this.getScheduleDate().toISOString()
      }
      if (this.donateId) {
        api
          .updateDonateBanner(this.donateId, params)
          .then(() => {
            this.loading = false;
            this.$router.push({ path: `/donates` });
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      } else {
        api
          .postBanner(params)
          .then(() => {
            this.loading = false;
            this.$router.push({ path: `/donates` });
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    validateScheduledDate() {
      if (this.postSchedule === 1) return true;
      if (!this.date || !this.time) return false;
      return new Date() <= this.getScheduleDate();
    },
    getScheduleDate() {
      const strISO8061 =  moment.tz(`${this.date} ${this.time}`, "Asia/Jerusalem").toISOString();
      return new Date(strISO8061);
    },
    getData() {
      this.$store.dispatch("SET_TOOLBARLOAD", true);
      api
        .showDonate(this.donateId)
        .then((res) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          const banners = res.data.banners;
          if (banners && banners.length > 0) {
            const currentBanner = banners[0];
            this.selectedDedication = currentBanner.dedication;
            this.name = currentBanner.name;
            this.motherName = currentBanner.mother_name;
            this.gender = currentBanner.gender;
            this.isAnonymous = currentBanner.is_anonymous;
            this.donorName = currentBanner.donor_name;
            const utcDate = moment(currentBanner.scheduled_at).tz("Asia/Jerusalem");
            this.date = utcDate.format("YYYY-MM-DD");
            this.time = utcDate.format("HH:mm");
            if ((new Date(currentBanner.scheduled_at) - new Date()) / 1000 > 0)
              this.postSchedule = 2;
          } else {
            this.selectedDedication = res.data.dedication;
            this.name = res.data.name;
            this.motherName = res.data.mother_name;
            this.isAnonymous = res.data.is_anonymous;
            this.donorName = res.data.donor_name;
          }
        })
        .catch((err) => {
          this.$store.dispatch("SET_TOOLBARLOAD", false);
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.isDonateBanner) {
      this.getData();
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  background: #F0F0F0;
}
.dedication-tab {
  padding: 20px 30px;
  border-radius: 10px;
  border-width: 1px;
  border-style: solid;
  border-color: #E6E6E6;
  background-color: #F0F0F0;
  cursor: pointer;
}
.dedication-tab.active {
  border-width: 2px;
  border-color: #000000;
}
.dedication-tab.active span.text-subtitle-2{
  font-weight: bold;
}
</style>
